<template>
	<div
		class="g-block-qrcode-nav-cell"
		:class="{
			'g-block-qrcode-nav-cell--edit': editable,
			'is-active': editable && active,
			'g-block-qrcode-nav-cell--h5': h5,
			'is-image-hidden': !showImage,
		}"
		:style="cellStyle"
		@click="onWrapClick"
	>
		<div
			v-if="showImage"
			class="g-block-qrcode-nav-cell__thumb"
		>
			<img
				v-if="imageUrl"
				:src="imageUrl"
				alt=""
			/>
			<i v-else class="mbm-iconfont mbm-tupian"></i>
		</div>
		<div class="g-block-qrcode-nav-cell__main">
			<div class="g-block-qrcode-nav-cell__title">{{ title }}</div>
		</div>
		<div class="g-block-qrcode-nav-cell__action" @click="onActionClick">
			<span>{{ actionText }}</span>
			<i class="mbm-iconfont mbm-youjiantou"></i>
		</div>
	</div>
</template>

<script>
	import { navigateJumpLink } from '../../../utils/jumpLink.js';
	import {
		getQrcodeNavCellStyle,
		getQrcodeNavImageUrl,
		QRCODE_NAV_TYPES,
	} from '../../../utils/qrcodeNav.js';

	export default {
		name: 'GQrcodeNavCellShell',
		props: {
			data: {
				type: Object,
				required: true,
			},
			editable: {
				type: Boolean,
				default: false,
			},
			active: {
				type: Boolean,
				default: false,
			},
			h5: {
				type: Boolean,
				default: false,
			},
		},
		emits: ['select'],
		computed: {
			showImage() {
				return this.data.showImage !== false;
			},
			title() {
				return this.data.title || '米家电热水壶使用说明';
			},
			actionText() {
				return this.data.actionText || '点击查看';
			},
			imageUrl() {
				return getQrcodeNavImageUrl(this.data.image);
			},
			cellStyle() {
				return getQrcodeNavCellStyle(QRCODE_NAV_TYPES.cell, this.data, { h5: this.h5 });
			},
		},
		methods: {
			onWrapClick(e) {
				if (this.editable) {
					e?.stopPropagation?.();
					this.$emit('select');
					return;
				}
				if (this.h5 && this.data.jumpLink?.type) {
					navigateJumpLink(this.data.jumpLink, {
						apiRequest: this.$apiRequest,
					});
				}
			},
			onActionClick(e) {
				this.onWrapClick(e);
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-qrcode-nav-cell {
		display: flex;
		align-items: center;
		gap: 12px;
		min-height: 56px;
		padding: 10px 14px;
		box-sizing: border-box;
		cursor: default;

		&--edit {
			border: 1px solid transparent;
			border-radius: 4px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}

		&--h5 {
			gap: 0.24rem;
			min-height: 1.12rem;
			padding: 0.2rem 0.28rem;
		}
	}

	.g-block-qrcode-nav-cell__thumb {
		flex-shrink: 0;
		width: 40px;
		height: 40px;
		border-radius: 50%;
		overflow: hidden;
		background: #e8e8e8;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			display: block;
		}

		i {
			font-size: 18px;
			color: #bfbfbf;
		}

		.g-block-qrcode-nav-cell--h5 & {
			width: 0.8rem;
			height: 0.8rem;

			i {
				font-size: 0.36rem;
			}
		}
	}

	.g-block-qrcode-nav-cell__main {
		flex: 1;
		min-width: 0;
	}

	.g-block-qrcode-nav-cell__title {
		font-size: 15px;
		font-weight: 500;
		line-height: 1.4;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;

		.g-block-qrcode-nav-cell--h5 & {
			font-size: 0.3rem;
		}
	}

	.g-block-qrcode-nav-cell__action {
		flex-shrink: 0;
		display: inline-flex;
		align-items: center;
		gap: 2px;
		font-size: 13px;
		color: inherit;
		opacity: 0.72;
		cursor: pointer;
		white-space: nowrap;

		i {
			font-size: 12px;
			line-height: 1;
		}

		.g-block-qrcode-nav-cell--h5 & {
			font-size: 0.26rem;
			gap: 0.04rem;

			i {
				font-size: 0.24rem;
			}
		}
	}
</style>
